<template>
  <component :is="`transaction-view-${layout}`"
             :transaction="transaction"
             :display-time="displayTime"
             :display-contractor="displayContractor"
             :currency-display="currencyDisplay"
             :mark-expense-category="markExpenseCategory"
             v-bind="arrowProp"
             @remove="$emit('remove',transaction.id)"
             @edit="$emit('edit',transaction)"/>
</template>

<script>
import TransactionViewCompact from "@/components/common/Transaction/TransactionView/TransactionViewCompact";
import TransactionViewDefault from "@/components/common/Transaction/TransactionView/TransactionViewDefault";
import TransactionViewBudget from "@/components/common/Transaction/TransactionView/TransactionViewBudget";
import TransactionViewFullDate from "@/components/common/Transaction/TransactionView/TransactionViewFullDate";
import transactionCurrencyDisplayProp from "@/mixins/transactionCurrencyDisplayProp";

export default {
  name: "TransactionItem",
  mixins:[transactionCurrencyDisplayProp],
  components: {
    TransactionViewFullDate,
    TransactionViewBudget,
    TransactionViewCompact,
    TransactionViewDefault
  },
  props: {
    layout: {
      type: String,
      default: 'default',
      validator: (value) => ['default', 'compact', 'budget', 'full-date'].includes(value)
    },
    transaction: {
      type: Object,
      required: true
    },
    markExpenseCategory: {
      type: Boolean,
      default: false
    },
    showTransferArrow: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayTime() {
      return this.$store.getters["space/spaceTimeEnabled"];
    },
    displayContractor() {
      return this.$store.getters["space/spaceUseContractors"];
    },
    arrowProp() {
      if (this.layout === 'compact' || this.layout === 'budget') return {};
      return {showTransferArrow: this.showTransferArrow};
    }
  }
}
</script>